<template>
  <div class="main-content">
    <!-- 页面标题 -->
    <div class="title">{{ $t('giftCard.title') }}</div>

    <!-- 搜索栏 -->
    <div class="search-box">
      <el-form :inline="true" :model="searchForm">
        <el-form-item :label="$t('giftCard.cardNo')">
          <el-input v-model="searchForm.cardNo" :placeholder="$t('giftCard.inputCardNo')" clearable></el-input>
        </el-form-item>
        <el-form-item :label="$t('common.status')">
          <el-select v-model="searchForm.status" :placeholder="$t('giftCard.selectStatus')" clearable>
            <el-option :label="$t('giftCard.unused')" :value="0"></el-option>
            <el-option :label="$t('giftCard.used')" :value="1"></el-option>
            <el-option :label="$t('giftCard.expired')" :value="2"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="getDataList()">{{ $t('common.search') }}</el-button>
          <el-button @click="resetSearch()">{{ $t('common.reset') }}</el-button>
        </el-form-item>
      </el-form>
    </div>

    <!-- 操作按钮 -->
    <div class="operate-box">
      <el-button type="primary" @click="showGenerateDialog">{{ $t('giftCard.batchGenerate') }}</el-button>
    </div>

    <!-- 数据列表 -->
    <el-table :data="dataList" border v-loading="dataListLoading" style="width: 100%">
      <el-table-column prop="cardNo" :label="$t('giftCard.cardNo')" align="center"></el-table-column>
      <el-table-column prop="amount" :label="$t('giftCard.amount')" align="center">
        <template slot-scope="scope">
          ¥{{ scope.row.amount }}
        </template>
      </el-table-column>
      <el-table-column prop="status" :label="$t('common.status')" align="center">
        <template slot-scope="scope">
          <el-tag :type="scope.row.status === 0 ? 'success' : scope.row.status === 1 ? 'info' : 'danger'">
            {{ scope.row.status === 0 ? $t('giftCard.unused') : scope.row.status === 1 ? $t('giftCard.used') : $t('giftCard.expired') }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="createTime" :label="$t('common.createTime')" align="center"></el-table-column>
      <el-table-column prop="expireTime" :label="$t('giftCard.expireTime')" align="center"></el-table-column>
      <el-table-column prop="useTime" :label="$t('giftCard.useTime')" align="center"></el-table-column>
    </el-table>

    <!-- 分页 -->
    <el-pagination
      @size-change="sizeChangeHandle"
      @current-change="currentChangeHandle"
      :current-page="pageIndex"
      :page-sizes="[10, 20, 50, 100]"
      :page-size="pageSize"
      :total="totalPage"
      layout="total, sizes, prev, pager, next, jumper">
    </el-pagination>

    <!-- 批量生成对话框 -->
    <el-dialog :title="$t('giftCard.batchGenerateGiftCards')" :visible.sync="generateDialogVisible" width="500px">
      <el-form :model="generateForm" :rules="generateRules" ref="generateForm" label-width="100px">
        <el-form-item :label="$t('giftCard.generateCount')" prop="count">
          <el-input-number v-model="generateForm.count" :min="1" :max="100"></el-input-number>
        </el-form-item>
        <el-form-item :label="$t('giftCard.amount')" prop="amount">
          <el-input-number v-model="generateForm.amount" :min="1" :precision="2" :step="0.01"></el-input-number>
        </el-form-item>
        <el-form-item :label="$t('giftCard.validityDays')" prop="expireDays">
          <el-input-number v-model="generateForm.expireDays" :min="1" :max="365"></el-input-number>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="generateDialogVisible = false">{{ $t('common.cancel') }}</el-button>
        <el-button type="primary" @click="generateGiftCards()">{{ $t('common.confirm') }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      searchForm: {
        cardNo: '',
        status: ''
      },
      dataList: [],
      pageIndex: 1,
      pageSize: 10,
      totalPage: 0,
      dataListLoading: false,
      generateDialogVisible: false,
      generateForm: {
        count: 1,
        amount: 100,
        expireDays: 365
      },
      generateRules: {
        count: [{ required: true, message: this.$t('giftCard.pleaseInputGenerateCount'), trigger: 'blur' }],
        amount: [{ required: true, message: this.$t('giftCard.pleaseInputAmount'), trigger: 'blur' }],
        expireDays: [{ required: true, message: this.$t('giftCard.pleaseInputValidityDays'), trigger: 'blur' }]
      }
    }
  },
  created() {
    this.getDataList()
  },
  methods: {
    // 获取数据列表
    getDataList() {
      this.dataListLoading = true
      this.$http({
        url: '/giftcard/page',
        method: 'get',
        params: {
          'page': this.pageIndex,
          'limit': this.pageSize,
          'cardNo': this.searchForm.cardNo,
          'status': this.searchForm.status
        }
      }).then(({data}) => {
        if (data && data.code === 0) {
          this.dataList = data.page.list
          this.totalPage = data.page.totalCount
        } else {
          this.dataList = []
          this.totalPage = 0
        }
        this.dataListLoading = false
      })
    },
    // 每页数
    sizeChangeHandle(val) {
      this.pageSize = val
      this.pageIndex = 1
      this.getDataList()
    },
    // 当前页
    currentChangeHandle(val) {
      this.pageIndex = val
      this.getDataList()
    },
    // 重置搜索条件
    resetSearch() {
      this.searchForm = {
        cardNo: '',
        status: ''
      }
      this.getDataList()
    },
    // 显示生成对话框
    showGenerateDialog() {
      this.generateDialogVisible = true
      this.$nextTick(() => {
        this.$refs['generateForm'].resetFields()
      })
    },
    // 生成礼品卡
    generateGiftCards() {
      this.$refs['generateForm'].validate((valid) => {
        if (valid) {
          this.$http({
            url: '/giftcard/generate',
            method: 'get',
            params: {
              'count': this.generateForm.count,
              'amount': this.generateForm.amount,
              'expireDays': this.generateForm.expireDays
            }
          }).then(({data}) => {
            if (data && data.code === 0) {
              this.$message({
                message: this.$t('giftCard.generateSuccess'),
                type: 'success',
                duration: 1500,
                onClose: () => {
                  this.generateDialogVisible = false
                  this.getDataList()
                }
              })
            } else {
              this.$message.error(data.msg)
            }
          })
        }
      })
    }
  }
}
</script>

<style scoped>
.main-content {
  padding: 20px;
}
.title {
  font-size: 22px;
  margin-bottom: 20px;
}
.search-box {
  margin-bottom: 20px;
}
.operate-box {
  margin-bottom: 20px;
      margin-top: 80px;
}
</style> 
 